export default {
	Slide: 'Diapositiva',

	Puzzle: 'Rompecabeza',

	'Block student': 'estudiante de bloque',

	Blocked: 'Obstruido',
	Unlocked: 'desbloqueado',

	'Show all blocked': 'Mostrar todos los bloqueados',

	Author: 'Autor',
	'Reset filters': 'Restablecer filtros',

	Change: 'Cambiar',
	'The student is blocked': 'El estudiante esta bloqueado',
	'The student is blocked with a new price':
		'El estudiante está bloqueado con un nuevo precio.',
	'To unlock this student, go to the "Restore" section':
		'Para desbloquear a este estudiante, vaya a la sección "Recuperación"',

	'Before blocking, you can change the price for the student':
		'Antes de bloquear, puedes cambiar el precio del estudiante.',

	'First month cost': 'Precio por 1 mes',

	'The puzzle is open!': 'El rompecabeza está abierto',
	'Congratulations!': '¡Felicidades!',
	'You get it': 'Lo lograste',
	'You get the task done': 'Has terminado la actividad',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'ATENCIÓN! Después de volver a guardar la tarea, los alumnos que la hayan completado tendrán el rompecabezas cerrado y tendrán que volver a hacerlo.',

	"You cannot do homework in the student's platform":
		'No se pueden hacer tareas en la plataforma del estudiante',

	'Restore the student ?': '¿Restituir al estudiante?',
	'Restore the teacher ?': '¿Restituir al instructor?',

	'Transition to 50': 'transición a 50',
	'Transition to 100': 'transición a 100',

	fifty: 'transición a 50',
	hundred: 'transición a 100',

	Faces: 'Rostros',

	Heroes: 'Héroes',
	Clothes: 'Prendas',
	Backgrounds: 'Fondos',
	Souvenirs: 'recuerdos',

	'Coming soon': 'Próximamente',

	'Wow! Congratulations, you have successfully purchased this product.':
		'¡Vaya! Felicidades, ha adquirido correctamente este producto',

	'You can view all your purchases in the "Purchased" section':
		'Puedes ver todas tus compras en la sección "Comprado":',

	'Your savings': 'Tus ahorros',

	'You can spend them on something interesting!':
		'¡Puedes gastarlos en algo interesante!',

	'A student with this email address already exists':
		'Ya existe un alumno con esta dirección de correo electrónico',

	///

	'User with such email already exists':
		'Ya existe un usuario con ese correo electrónico',

	'Year of birth': 'Año de nacimiento',

	Registration: 'Inscripción',

	'Surname of parents': 'Apellido de los padres',

	School: 'Escuela',

	///

	'Field is required': 'Campo obligatorio',
	'Select age': 'Seleccione la edad',
	'No such teacher for this year': 'El profesor no está disponible',
	'User with such phone number already exists':
		'Ya existe un usuario con ese número telefónico',

	///

	'You are successfully registered': 'Se ha registrado satisfactoriamente',
	'Max length 20 chars': 'Máximo 20 caracteres',

	'INTERNATIONAL SCHOOL': 'Escuela Internacional',
	'Mental Arithmetic': 'Aritmética Mental',

	'For children aged 5-14.': 'Para niños entre 5-14 años de edad.',
	'Sign up for a trial lesson': 'Inscríbase para una clase demostrativa',
	'Parents name': 'Nombre del responsable',
	'Childs age': 'Edad del niño',

	///

	Country: 'País',

	///

	'Sign up': 'Regístrese',
	'Open offer agreement': 'Acuerdo',
	'Participate in online Indigo Olympiad':
		'Participa en las Olimpiadas de Indigo en línea',

	///

	Participate: 'Participa',
	export: 'Exportar',

	wrong: 'Incorrecto',
	right: 'Correcto',
	'Only task': 'Actividad',
	match: {
		//emparejar
		addition: 'adición ',
		multiply: 'Multiplicación',
		divide: 'División',
		abacus_random: 'Ábaco aleatorio',
		anzan: 'Anzan',
		negative: 'Números negativos',
		column: 'Columnas',
	},

	timeIsOver: 'Se terminó el tiempo',
	timer: 'cronómetro',

	'Back to Lessons': 'Volver a Lecciones',
	'Create Lesson': 'Crear lección',
	Home: 'Inicio',
	Assign: 'Designar',
	'To cabinet': 'Al armario',
	'Create a homework': 'Crear una tarea',

	January: 'Enero',
	February: 'Febrero',
	March: 'Marzo',
	April: 'Abril',
	May: 'Mayo',
	June: 'Junio',
	July: 'Julio',
	August: 'Agosto',
	'Group nickname': 'Apodo del grupo',
	September: 'Septiembre',
	October: 'Octubre',
	November: 'Noviembre',
	December: 'Diciembre',

	Overall: 'En total',
	Active: 'Activo',
	'Contract number': 'Número de contrato',
	'For parents': 'Para los padres',
	'Choose lessons': 'Elegir lecciones',
	Save: 'Asignar',
	Close: 'Cerrar',
	'Change birthday': 'Cambiar fecha de nacimiento',
	Sent: 'Enviado',
	'Include students': 'Incluir estudiantes',
	'Add service': 'Añadir servicio',
	'Create folder': 'Crear carpeta',
	Answer: 'Respuesta',
	Price: 'Precio',
	'Date of creating': 'Fecha de creación',
	Month: 'Mes',
	unpaid: 'Sin pagar',
	paid: 'Pagado',
	'Excluded students': 'Alumnos excluidos',
	'Selected groups': 'Grupos seleccionados',

	Monday: 'Lunes',
	Tuesday: 'Martes',
	Wensday: 'Miércoles',
	Thusday: 'Jueves',
	Friday: 'Viernes',
	Saturday: 'Sábado',
	Sunday: 'Domingo',

	Mo: 'Lu',
	Tu: 'Ma',
	We: 'Mi',
	Th: 'Ju',
	Fr: 'Vi',
	Sa: 'Sa',
	Su: 'Do',
	End: 'Fin',
	'Add discount': 'Añadir descuento',
	Edit: 'Editar',

	'Parent found': 'Padre encontrado',
	'Changes saved': 'Cambios guardados',
	'The passwords of the parent and the student should not coincide':
		'Las contraseñas de padres y alumnos no deben coincidir',

	'Your region`s price is set to': 'El precio de tu región está fijado en',
	'and the holder`s reward is': 'y la recompensa del titular es ',
	'regardless of the set price': 'independientemente del precio fijado',
	'The given password is not unique for this email':
		'La contraseña dada no es única para este correo electrónico',

	'Enter a valid email address.':
		'Introduzca una dirección de correo electrónico válida',
	'The phone number entered is not valid':
		'El número de teléfono introducido no es válido',
	Holiday: 'Vacaciones',
	'Working days': 'Días laborables',
	Street: 'Calle',
	'Location name': 'Nombre de la ubicación',
	District: 'Distrito',
	'Field required': 'Campo obligatorio',
	'Type of legal activity': 'Tipo de actividad jurídica',
	'Legal address': 'Dirección legal',
	'Registration number': 'Número de registro',
	'Add Group': 'Añadir grupo',
	'Add Student': 'Añadir estudiante',

	///

	Signin: 'Iniciar sesión',

	///

	'Bonus days': 'Días extra',
	'Bonus weeks': 'Semanas extra',
	'Are you sure you want to delete?': '¿Seguro que quieres borrar?',
	Delete: 'Borrar',
	Days: 'Días',
	Confirm: 'Confirmar',
	Cancel: 'Cancelar',
	Week: 'Semana',
	Weeks: 'Semanas',
	'Group age name': 'Nombre de la categoría de edad',
	'Set bonus days': 'Establecer días de bonificación',
	'Default language': 'Idioma predeterminado',
	'With english': 'Con inglés',
	'Without english': 'Sin inglés',
	'Paid status': 'Estado de pago',
	'Not paid': 'No pagado',
	Turnover: 'facturación',
	Block: 'Bloquear',
	Blocked: 'Bloqueado',
	'On holidays': 'De vacaciones',
	Language: 'idioma',
	Discounts: 'Descuentos',
	Message: 'ПMensaje',
	Subject: 'Asunto',
	Homework: 'Tarea',
	'Homework ': 'Tarea ',
	'Homework on': 'Tarea sobre',

	'Sum Sub': 'Suma y Resta',

	'You need to complete the exercises': 'Tienes que completar los ejercicios',

	'Invoice for': 'Factura de',
	'PJSC CB "PRIVATBANK" in Kyiv': 'ПАТ КБ "ПРИВАТБАНК" м. Київа',
	Account: 'Cuenta',
	Supplier: 'Proveedor',
	Buyer: 'Comprador',
	'Bank code': 'Código bancario',
	'Type phone number or email':
		'Escriba el número telefónico o la dirección de correo electrónico',
	'Type password': 'Introduzca la contraseña',
	'Forgot password': 'Olvidé mi contraseña',
	'Type your email': 'Introduzca su correo electrónico',
	Send: 'Enviar',
	'Email sent': 'Correo electrónico enviado',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Si estás inscrito en el proyecto, recibirás un correo electrónico con las instrucciones para volver a acceder a tu correo.',

	'Back to the sign in': 'Volver al inicio de sesión',
	'Password or login is not correct':
		'La contraseña o el nombre de usuario no son correctos',
	'Password recovery': 'Recuperar contraseña',
	'Type your new password here': 'Introduzca aquí su nueva contraseña',
	'Set new password': 'Establecer una nueva contraseña',
	'Learn more': 'Más información',
	'About Us': 'Quiénes somos',
	Company: 'La empresa',
	Jobs: 'Empleos',
	Press: 'Prensa',
	'Terms of Use': 'Condiciones de uso',
	'Privacy Policy': 'Política de privacidad',
	'Need help?': '¿Necesita ayuda?',
	'Contact us': 'Contáctenos',
	'Become franchise': 'Conviértase en franquicia',
	'Select language': 'Seleccionar idioma',
	English: 'Inglés',
	Russian: 'Ruso',
	Azerbaijani: 'Azerbaiyán',
	Ukrainian: 'Ucraniano',
	Polish: 'Polaco',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'La aritmética mental es una técnica de conteo oral que desarrolla rápidamente la capacidad intelectual y la inteligencia de un niño de entre 5 y 14 años. El proceso de entrenamiento tiene lugar utilizando las cuentas en el ábaco japonés (Soroban). La aritmética mental entrena simultáneamente los hemisferios izquierdo y derecho del cerebro, mejorando la memoria visual, la concentración de la atención, la orientación creativa, el pensamiento imaginativo de los niños y su tendencia a la lectura rápida.',
	Management: 'Administración',
	'Master Franchise': 'Franquicia Maestra',
	Franchise: 'Franquicia',
	Teachers: 'Profesores',
	Groups: 'Grupos',
	Students: 'Estudiantes',
	Student: 'Estudiante',
	Parents: 'Padres',
	Profile: 'Perfil',
	'My profile': 'Mi perfil',
	Finance: 'Finanzas',
	Reports: 'Reportes',
	Report: 'Reporte',
	Upload: 'Subir',
	List: 'Lista',
	Payments: 'Pagos',
	Documents: 'Documentos',
	Lessons: 'Lecciones',
	Materials: 'Material',
	Shop: 'Tienda',
	Statistics: 'Estadísticas',
	Settings: 'Ajustes',
	Pages: 'Páginas',
	Logout: 'Cerrar sesión',
	Dashboard: 'Pantalla principal',
	'Access denied': 'Acceso denegado',
	Create: 'Crear',
	Download: 'Descargar',
	Status: 'Estado',
	'Payment Date': 'Fecha de pago',
	'Payment Amount': 'Monto a pagar',
	'Start time': 'Fecha de inicio',
	'Group age': 'Edad del grupo',
	Junior: 'Pequeño',
	Average: 'Promedio',
	Class: 'Clase',
	Older: 'Mayor',
	Region: 'Región',
	Group: 'Grupo',
	Person: 'Persona',
	Finances: 'Finanzas',
	Actions: 'Acciones',
	'Choose date': 'Seleccione la fecha',
	'Send invoice': 'Enviar el recibo”',
	'Download invoice': 'Descargar el recibo',
	'Send email': 'Enviar email',
	'Create Student': 'Crear un perfil de estudiante',
	'The beginning of holidays': 'Inicio de vacaciones',
	'Start of study': 'Inicio de clases',
	'Group name': 'Nombre del grupo',
	'Group address': 'Dirección del grupo',
	'Group teacher': 'Profesor del grupo',
	'Group students': 'Estudiantes del grupo',
	'Group statistics': 'Estadísticas del grupo',
	Tasks: 'Tareas',
	'Only task': 'sólo tarea',

	'Current task': 'tarea actual',
	'Next tasks': 'tareas siguientes',
	Search: 'Buscar',
	'General information': 'Información general',
	'Phone number': 'Número telefónico',
	'First name': 'Primer nombre',
	Surname: 'Segundo nombre',
	'Last name': 'Apellido',
	'Date of birth': 'Fecha de nacimiento',
	Password: 'Contraseña',
	'Additional information': 'Información adicional',
	'Id code': 'Código ID',
	Passport: 'Pasaporte',
	'With email newsletter': 'Con boletín informativo al correo electrónico',
	'Without email newsletter': 'Sin boletín informativo al correo electrónico',
	'Financial information': 'Información financiera',
	Royalty: 'Regalías',
	'PR contribution': 'Contribución PR',
	Currency: 'Moneda',
	Comment: 'Comentario',
	Paid: 'Pagado',
	Invoices: 'Recibos',
	Payer: 'Encargado de pago',
	'Payment order': 'Orden de pago',
	Code: 'Código',
	'Bank of the recipient': 'Banco del beneficiario',
	Acts: 'Actos',
	Scan: 'Escanear',
	'Period report': 'Período de reporte',
	City: 'Ciudad',
	'Full name franchise': 'Nombre completo de la franquicia',
	'Students active': 'Estudiantes activos',
	'Сost of education': 'Costo de educación',
	'Turnover franchise': 'Facturación de franquicia',
	'Discount sum': 'Suma de descuento',
	Proprietor: 'Propietario',
	'Additional products and services': 'Productos y servicios adicionales',
	'Full name student': 'Nombre completo del estudiante',
	'Period of study': 'Periodo de estudio',
	'Bonus-days': 'Días adicionales',
	'The beginning of the holidays': 'El inicio de las vacaciones',
	'Amount of days': 'Cantidad de días',
	'Total days': 'Días totales',
	'Language of instruction': 'Idioma de instrucción',
	Teacher: 'Maestro',
	Discount: 'Descuento',
	Remuneration: 'Remuneración',
	Goods: 'Artículos',
	'Date of creation': 'Fecha de creación',
	'Date of payment': 'Fecha de pago',
	'Goods (works, services)': 'Artículos (trabajos, servicios)',
	Quantity: 'Cantidad',
	Units: 'Unidades',
	Amount: 'Cantidad',
	Sum: 'Suma',
	Financial: 'Financiera',
	Additional: 'Adicional',
	General: 'General',
	Total: 'Total',
	Save: 'Ahorre',
	'Including with': 'Incluyendo',
	'Training materials': 'Materiales de entrenamiento',
	'Learning contract': 'Contrato de aprendizaje',
	Games: 'Juegos',
	'NUMBER OF 11 TO 120': 'Números del 11 al 120',
	Complexity: 'Dificultad',
	Start: 'Iniciar',

	///

	'Adding and Subtracting': 'Suma y Resta',

	///

	Anzan: 'Anzan',
	'Abacus is random': 'El Ábaco es aleatorio',
	Multiplication: 'Multiplicación',
	Division: 'División',
	Abacus: 'Ábaco',
	'Multiplying by 20': 'Multiplicando por 20',
	Squared: 'Al cuadrado',
	'Division to 20': 'División de 20',
	Speed: 'Velocidad',
	Repeat: 'Repetir',
	'Game type': 'Tipo de juego',
	'Digit type': 'Тип чисел',
	Digit: 'Tipo de dígito',
	Time: 'Tiempo',
	Second: 'Segundo',
	Level: 'Nivel',
	'Action with numbers': 'Cantidad de números',
	'Action with number': 'Cantidad de números',
	'Number of expressions': 'Número de expresiones',
	'Number of expression': 'Número de expresiones',
	'Imaginary abacus': 'Ábaco imaginario',
	'Calculation method': 'Método de cálculo',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Sólo números negativos comenzando con 99,999,9999 etc, dependiendo de la dificultad de la expresión: -9,-2, -3, -1...',
	'Only subtraction': 'Sólo restas',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Sólo números positivos comenzando con 0. Expresiones: +1, +4, +6, +9, +5 ...',
	'Only add': 'Sólo sumas',
	'Numbers fall randomly, starting with 0. Expression : +3, -5, -1, +9, -2 ...':
		'Números aleatorios, comenzando con 0. Expresion: +3, -5, -1, +9, -2 ...',
	'Random numbers': 'Números aleatorios',
	'CHOOSE COMPLEXITY:': 'Selecciona la dificultad',
	'AMOUNT OF ACTIONS WITH NUMBER': 'Cantidad de números a calcular',
	FAMILY: 'Familia',
	'BIG FRIENDS': 'Grandes amigos',
	'LITTLE FRIENDS': 'Pequeños amigos',
	'JUST FRIENDS': 'Solo amigos',
	family: 'Familia',
	'big friends': 'Grandes amigos',
	'small friends': 'Pequeños amigos',
	elementary: 'Básico',
	Sound: 'Sonido',
	Loading: 'Cargando',
	back: 'Atrás',
	Back: 'Atrás',
	Add: 'Añadir',
	'Add file': 'Añadir archivo',
	ANSWER: 'Respuesta',
	'Congratulations! You did it! Now you can go to the following exercises':
		'¡Felicidades! Lo lograste. Ahora puedes continuar con los siguientes ejercicios',
	'RIGHT. ANSWER:': 'Respuesta correcta:',

	CORRECT: 'Correcto',

	'NOT CORRECT': 'Incorrecto',
	'Try again': 'Inténtalo de nuevo',
	expression: 'Expresión',
	Lesson: 'Lección',
	Oral: 'Oral',
	'History statistics': 'Historial de estadísticas',
	Open: 'Abierto',
	'Game statistics per day': 'Estadísticas de juego por día',
	'Total played games': 'Total de juegos completados',
	'Total correct answers': 'Total de respuestas correctas',
	'Total played:': 'Total jugado',
	Feedback: 'Comentarios',
	'Leave a review': 'Deja un comentario',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Déjanos tus comentarios o deseos y definitivamente los consideraremos en nuestro trabajo',
	next: 'Siguiente',
	Next: 'Siguiente',
	Previous: 'Anterior',
	'Payment history': 'Historial de pago',
	'Payment status': 'Estado de pago',
	Pay: 'Pagar',
	'Getting a discount': 'Obtener un descuento',
	Training: 'Entrenamiento',
	'Online abacus': 'Ábaco virtual',
	'Base 50/100': 'Base 50/100',
	multiply_base: 'Base de multiplicación',
	divided: 'Dividido',
	'Do not show this instruction again':
		'No mostrar esta instrucción nuevamente',
	'Instructions for homework': 'Instrucciones para realizar la tarea',
	divider: 'Divisor',
	'Multiplication table': 'Tabla de multiplicar',
	Restore: 'Restablecer',
	Left: 'Restante',
	New: 'Nuevo',
	'Restore Hierarchy': 'Restablecer jerarquía',
	total: 'Total',
	active: 'Activo',
	blocked: 'Bloqueado',

	pageError: {
		//Error de página
		'403': 'Acceso denegado',
		'404': 'Esta página no existe. Regrese a la página anterior.',
		'500': 'El servidor no responde. Inténtelo más tarde.',
	},

	error: {
		'Account deactivated': 'Su cuenta ha sido desactivada',
	},

	modalNewVersion: {
		text:
			'Está utilizando una versión obsoleta del sitio web.\nUna versión actualizada está disponible.',
		btn: 'Actualizar',
	},

	games: {
		//juegos
		negativeNumbers: 'Números Negativos',

		pause: 'Detener',
		resume: 'Continuar',

		columns: {
			//Columnas
			name: 'Columnas',
			users: 'Número de jugadores',
			user: 'Jugador',
			userNames: 'Nombre del jugador',
		},
	},

	'Indigo-dollars': 'Indigo dólares',

	Balance: 'Balance',

	modalIndigoDollars: {
		submit: 'Enviar',
		cancel: 'Cancelar',
		title: 'Indigo dólares',
		balance: 'Balance',
		amount: 'Cantidad',
		reason: 'Comentario',
	},

	modalAddNotification: {
		title: 'Agregar notificaciones',
		submit: 'Enviar',
		cancel: 'Cancelar',
		empty: 'Sin notificaciones',
	},

	modalTransactionsHistory: {
		title: 'Historial de Pago',
		type: {
			withdraw: 'Anular',
			deposit: 'Depositar',
		},
		empty: 'La lista de pagos está vacía',
	},
	modalCopyHomework: {
		title: 'Copiar Tarea',
		label:
			'Seleccionar el número de rompecabezas al que desea copiar la tarea.',
		submit: 'Copiar',
		cancel: 'Cancelar',
	},

	reportsPage: {
		history: {
			title: 'Cambiar Historial',
			empty: 'La lista está vacía',
			table: {
				date: 'Fecha de modificación',
				field_name: 'Acción',
				old_value: 'Valor anterior',
				new_value: 'Nuevo valor',
				user: 'Modificado por el usuario',
			},
		},
	},

	pageShop: {
		title: 'Tienda decorativa',
		description:
			'En esta tienda puedes usar tus Indigo dólares para comprar decoraciones y personalizar la apariencia de la plataforma.',

		tabs: {
			all: 'Todas las decoraciones',
			purchased: 'Comprado',
		},

		item: {
			off_all: 'No',

			status: {
				AVAILABLE: 'Disponible',
				DEPRECATED: 'No disponible',
				COMING_SOON: 'Próximamente',
			},
			is_activated: 'Seleccionado',
			set_active: 'Seleccionar',
			unset_active: 'Deshabilitar',
			preview: 'Vista previa',
			is_free: 'Gratis',
			buy: 'Comprar',
			bought: 'Comprado',
			purchased: 'Comprado',
		},
		empty: {
			all: 'No hay decoraciones disponibles',
			purchased: 'No hay decoraciones compradas',
		},

		toast: {
			error: 'Ha ocurrido un error',
			notEnoughMoney: 'Fondos insuficientes',
			itemBought: 'Decoración comprada',
			itemActivated: 'Decoración activada',
			itemDeactivated: 'Decoración desactivada',
		},
		confirmPurchase: {
			title: 'Confirmar compra',
			message: '¿Estás seguro de que quieres comprar este artículo?',
			confirm: 'Sí, comprar',
			cancel: 'Cancelar',
		},
	},

	demo: {
		title: 'Clase demostrativa gratuita',
		tutorial: {
			title: 'Instrucción',
			text:
				'Bienvenido a Indigo Mental, lección virtual gratuita sobre aritmética mental. Indigo Mental es la mejor escuela de aritmética mental del mundo, los muchos años de experiencia de la empresa y el éxito de muchos estudiantes de todo el mundo en las Olimpiadas de Matemática Mental nos respaldan cuando decimos que esta técnica es eficaz , única y funcional. Muchos padres llevan mucho tiempo fascinados con la metodología, y disfrutan ver el éxito que tienen sus hijos, no solo en aritmética, sino en otras áreas tales como la música y deportes. Además, notan un gran adelanto en las capacidades intelectuales de sus hijos. La aritmética mental es un método japonés de cálculo oral rápido, que desarrolla rápidamente las habilidades mentales y la inteligencia del niño. Durante el proceso de aprendizaje se utiliza el Ábaco japonés (Soroban). La aritmética mental entrena ambos hemisferios del cerebro (izquierdo y derecho) al mismo tiempo, mejorando la memoria visual, la concentración de la atención, y también fomenta la creatividad y el pensamiento imaginativo de los niños. Comencemos a practicar la aritmética mental, por favor pulse en el botón "JUGAR" en el video de abajo, escuche y repita.',
		},
	},

	disableStudent: {
		btn: 'Desconectar estudiante',
		list: 'Estudiantes sin fecha de desactivación',
		modal: {
			title: 'Desconectando un estudiante',
			description: 'Estás a punto de deshabilitar a un estudiante',
			fieldLabel: 'Seleccionar mes',
			btnSubmit: 'Deshabilitar',
			btnCancel: 'Cancelar',
		},
	},
}
